const STORAGE_KEY = 'kot-color-mode';

export function isKotDark() {
  return document.documentElement.classList.contains('kot-dark');
}

export function setKotDark(enabled) {
  document.documentElement.classList.toggle('kot-dark', Boolean(enabled));
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'dark' : 'light');
  } catch (err) {
    /* ignore private-mode storage failures */
  }
}

export function initKotDark() {
  let saved = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch (err) {
    saved = null;
  }
  setKotDark(saved === 'dark');
}

export function toggleKotDark() {
  const next = !isKotDark();
  setKotDark(next);
  return next;
}
